import React from 'react';
import { Link } from 'react-router-dom';
import { CheckedSuccessIcon } from './Svg';

export default function CourseRegistrationSuccessful() {
  return (
    <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
      <h1>Register Courses</h1>
      {/* card for course registration  */}
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="card min-h-1000 text-center justify-content-center align-items-centerr">
            <div className="registering-courses p-0 m-0">
              <button className="circle-bg-width-80 circle-bg circle-bg-green checked-icon justify-content-center align-items-center">
                {/* <img src="./assets/checked.svg" />
                 */}
                <CheckedSuccessIcon />
              </button>
              <h2>Courses Registered</h2>
              <p className="small">
                You have successfully registered your courses for this semester
              </p>
              <Link
                to="/courses/registered"
                className="btn btn-primary btn-primary-color"
              >
                View Registered Courses
              </Link>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>
      {/* end card for news display   */}
    </main>
  );
}
